import UnauthenticatedPage from './unauthenticated-page';

export default UnauthenticatedPage;
